import {Button, Stack, Typography} from '@mui/material';
import {Modal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {CommunicateModalProps} from './types';

const {
	title,
	attention,
	sectionOne,
	sectionTwo,
	sectionThree,
	sectionFour,
	sectionFive,
	sectionSix,
	sectionSeven,
} = translations['pt-br'].privateFlow.refund.beneficiaryDataPage.modals.communicate;
const {understood} = translations['pt-br'].commons;

export const CommunicateModal = ({open, setOpen}: CommunicateModalProps) => (
	<Modal.Root open={open} onClose={() => setOpen(false)}>
		<Modal.Header title={title} onClose={() => setOpen(false)} />
		<Modal.Content>
			<Stack spacing={2}>
				<Typography variant="subtitle1" fontWeight={600}>
					{sectionOne}
				</Typography>

				<Typography variant="body1" fontWeight={700}>
					{sectionTwo}
				</Typography>

				<Typography variant="body1">{sectionThree}</Typography>

				<Typography variant="body1">{sectionFour}</Typography>

				<Typography variant="body1" fontWeight={700}>
					{sectionFive}
				</Typography>

				<Typography variant="body1">
					<b>{attention}:</b> {sectionSix}
				</Typography>

				<Typography variant="body1">{sectionSeven}</Typography>
			</Stack>
		</Modal.Content>

		<Modal.Footer>
			<Button
				fullWidth
				variant="contained"
				size="large"
				color="primary"
				onClick={() => setOpen(false)}>
				{understood}
			</Button>
		</Modal.Footer>
	</Modal.Root>
);
